import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

export interface PeriodicElement {
    channel: string;
    media: string;
    impressions: string;
    plays: string;
    total: string;
    cost: string;
}

@Component({
    selector: 'app-channel-performance',
    templateUrl: './channel-performance.component.html',
    styleUrls: ['./channel-performance.component.scss']
})
export class ChannelPerformanceComponent implements OnInit {
    /** table  **/
    public ELEMENT_DATA: PeriodicElement[] = [
        {
            channel: 'CH 1455',
            media: '3',
            impressions: '108',
            plays: '2900',
            total: 'USD 4,200.00',
            cost: 'USD 10.00'
        },
        {
            channel: 'CH 1455',
            media: '3',
            impressions: '108',
            plays: '2900',
            total: 'USD 4,200.00',
            cost: 'USD 10.00'
        },
        {
            channel: 'CH 1455',
            media: '3',
            impressions: '108',
            plays: '2900',
            total: 'USD 4,200.00',
            cost: 'USD 10.00'
        },
        {
            channel: 'CH 1455',
            media: '3',
            impressions: '108',
            plays: '2900',
            total: 'USD 4,200.00',
            cost: 'USD 10.00'
        }
    ];

    displayedColumns: string[] = ['channel', 'media', 'impressions', 'plays', 'total', 'cost'];
    dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);

    constructor() {}

    ngOnInit() {}
}
